import React from "react";
import StyledLgText from "../../common/components/styledLgText/StyledLgText";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";

const ShowMinted = ({ data, handleTabClick, activeTab, width }) => {
  return (
    <div
      className={`${width} flex justify-evenly items-center yellow-border py-4`}
    >
      <StyledLgText>Show NFTs:</StyledLgText>
      {data.map((tab, index) => (
        <button
          key={index}
          onClick={() => handleTabClick(tab.title)}
          className={`${
            activeTab === tab.title ? "text-bright-yellow" : "text-white"
          }`}
        >
          <StyledMdText>{tab.title}</StyledMdText>
        </button>
      ))}
    </div>
  );
};

export default ShowMinted;
